const local = {
    // API_END_POINT : 'http://127.0.0.1:3100/v1/switching/low',
    // API_END_POINT2: 'http://127.0.0.1:3100/v1/switching/occto/low',
    API_END_POINT: 'http://localhost:8080/v1/switching/low',
    API_END_POINT2: 'http://localhost:8080/v1/switching/occto/low',
    OKTA_AUTH_MODE: true,
    OKTA_ISSUER_URL: 'https://grandata.okta.com/',
    OKTA_CLIENT_ID: '0oa1di7az37rmPoHg697',
    OKTA_JWT_TYPE: 'client_secret_jwt',
    OKTA_CLIENT_SECRET: '0lPN4bhT2Gl0VPqvXj85uOtAiN2HQ3BaCQs4VFky_WU',
    OKTA_PRIVATE_KEY: '',
    ERROR_MODE    : true,
};
export default local;